import { FaSign } from "react-icons/fa";

export default FaSign;